"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ParametersProvider {
    register(parameters) {
        this.parameters = parameters;
    }
    getAll() {
        return this.parameters;
    }
    get(key) {
        return this.dotGet(this.parameters, key);
    }
    dotGet(object, key) {
        return key.split('.').reduce((result, key) => {
            if (typeof result !== 'object') {
                return result;
            }
            return result[key];
        }, object);
    }
}
exports.ParametersProvider = ParametersProvider;
exports.parametersProvider = new ParametersProvider();



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-parameters-provider/ParametersProvider.ts